import React, { Fragment, useState } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { BiCloudDownload } from "react-icons/bi";
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import Edit from './Edit';
import Delete from './Delete';
import Modal from 'components/Modal';

const ViewList = ({ data, index, ...props }) => {
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr className={`${index % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{index + 1}</TD>
        <TD>{data?.make?.make}</TD>
        <TD>{data?.model?.name}</TD>
        <TD>{data?.name}</TD>
        <TD>{data?.axleConfiguration}</TD>
        <TD>{data?.wheelCount}</TD>

        <TD>{data?.tyrePositions.map((p) => p).join(", ")}</TD>
        {/* <TD ><div className="break-all">{JSON.stringify(data?.automaticPositions)}</div></TD> */}
        <TD>
          {data.createdAt ? new Date(data.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-') : ""}
        </TD>
        <TD>
          {checkPermission([permissions.manage_masters], currentUser) ? (
            <div className="">
              <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button>
              <button
                // disabled = {data.vehicles}
                onClick={() => {if(data.vehicles) setShowBlockModal(true); else setShowDeleteModel(true)}}
                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
              >
                <FaTrash />
              </button>
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showEditModel && (
        <Edit key={data._id} data={data} handleClick={() => {setShowEditModel(false); props.getData();}} />
      )}
      {showDeleteModel && (
        <Delete data={data} handleClick={() => setShowDeleteModel(false)} />
      )}
      {showBlockModal && (
        <Modal handleClick={()=>{ setShowBlockModal(false)}} title={"Delete Configuration"} className="max-w-2xl h-[20vh]">
          <p className="text-red-500 p-5 text-center">
            OOPS! This configuration has already been assigned to vehicles </p>
          </Modal>
      )}
    </Fragment>
  );
};

export default ViewList;
